// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgClass, NgStyle } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { ASSETS } from '../../../../assets/assets';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';
import { MaskHelper } from '../input-text/mask-input.helper';

@Component({
  selector: 'lbca-input-text-condensed',
  templateUrl: './input-text-condensed.component.html',
  styleUrl: './input-text-condensed.component.scss',
  imports: [NgStyle, NgClass, IconComponent],
})
export class InputTextCondensedComponent {
  private overlay = inject(Overlay);
  readonly assets = inject(ASSETS);

  private popupFeedController = new PopupInterfaceCommunication();

  private maskHelper: any = null;

  @Input() set maskInput(maskType: string) {
    if (maskType) this.maskHelper = new MaskHelper(maskType, undefined as any, this.assets);

    if (maskType && this.maskHelper) {
      this.hasMask = true;

      this.setValueUserEventToMaskCallback = (value, cursorPosition) => {
        const { newValue, newCursorPosition } = this.maskHelper.getPureValue(value, cursorPosition);
        const { formatedValue, formatedCursorPosition } = this.maskHelper.getMaskedValue(
          newValue,
          newCursorPosition
        );
        return { pureValue: newValue, formatedValue, formatedCursorPosition };
      };
      this.setValueInputToMaskCallback = (value) => {
        const { formatedValue } = this.maskHelper.getMaskedValue(value, value.length);
        return formatedValue;
      };
      this.validateCallback = async (value) => {
        return {
          isValid: await this.maskHelper.validate(value),
          insertIcon: this.maskHelper.getInsertIconValidate(),
        };
      };
      this.getMaskErrorCallback = () => {
        return this.maskHelper.getError();
      };
    }
  }

  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('templateCopy') templateCopy!: TemplateRef<any>;

  private errorPopup!: ErrorOverlayClass;

  @ViewChild('inputData', { static: true }) inputData!: ElementRef;

  public hasMask: boolean = false;

  public isTouched: boolean = false;
  public hasError: boolean = false;
  public isRequired: boolean = false;
  public isDisabled: boolean = false;
  public isEditable: boolean = false;

  public isValidIcon: boolean = false;
  public isLabeled: boolean = false;
  public isTabeled: boolean = false;
  public copy: boolean = true;

  public labelValue: string = '';
  public helperTextValue: string = '';
  public placeholder: string = '';

  public maskIcon: any = null;

  public inputComponetIconStyle: any = null;
  public inputComponetIconSize: 'sm' | 'normal' = 'normal';
  public inputComponetHelperIconStyle: any = null;
  public componentFilling: any = null;

  public valueToReturn: any = '';

  private readInputTimeOutDebounce: any = null;

  private setValueUserEventToMaskCallback: any = null;
  private setValueInputToMaskCallback: any = null;
  private validateCallback: any = null;
  private getMaskErrorCallback: any = null;

  constructor() {
    const overlay = this.overlay;
    const elementRef = inject(ElementRef);

    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ],
      0,
      0,
      'top',
      'end'
    );
  }

  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set hasExternalError(value: boolean) {
    this.hasError = value;
  }
  @Input() set copyContent(value: boolean) {
    this.copy = value;
  }

  @Input() set componetIconStyle(icon: string) {
    this.inputComponetIconStyle = icon;
  }
  @Input() set componetHelperIconStyle(icon: string) {
    this.inputComponetHelperIconStyle = icon;
  }
  @Input() set componetIconSize(icon: 'sm' | 'normal') {
    this.inputComponetIconSize = icon;
  }

  @Input() set spacing(value: string) {
    this.componentFilling = value;
  }

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set value(value) {
    if (value) {
      // await mask initialization
      setTimeout(() => {
        this.valueToReturn = value;
        this.isTouched = true;
        if (!this.hasMask) this.inputData!.nativeElement.value = value;
        else this.inputData!.nativeElement.value = this.setValueInputToMaskCallback(value);
        setTimeout(() => this.checkIsValidate(), 50);
      }, 5);
    }
  }

  @Output('changeValue') changeEmmiter = new EventEmitter();

  @Output() focusState = new EventEmitter();

  @Output('setError') setErrorEmmiter = new EventEmitter();
  @Output('validStatus') validStatusEmmiter = new EventEmitter();

  public inputKeyUpEvent($event) {
    clearTimeout(this.readInputTimeOutDebounce);

    this.hasError = false;
    this.isValidIcon = false;

    this.readInputTimeOutDebounce = setTimeout(() => {
      if (this.hasMask) {
        const cursorStart = $event.target.selectionStart;
        const { pureValue, formatedValue, formatedCursorPosition } =
          this.setValueUserEventToMaskCallback($event.target.value, cursorStart);

        this.valueToReturn = pureValue;
        $event.target.value = formatedValue;

        if ($event.code.substring(0, 5) === 'Arrow') return;
        if ($event.code.substring(0, 5) === 'Shift') return;
        if ($event.code.substring(0, 7) === 'Control') return;

        $event.target.selectionEnd = formatedCursorPosition;
        $event.target.selectionStart = formatedCursorPosition;
        this.validStatusEmmiter.emit(false);
      } else {
        this.valueToReturn = $event.target.value;
        if (this.valueToReturn) this.validStatusEmmiter.emit(true);
        else this.validStatusEmmiter.emit(false);
      }
      this.changeEmmiter.emit(this.valueToReturn);
    }, 25);
  }

  public focusIn(): void {
    this.isTouched = true;
    this.focusState.emit(true);
    this.errorPopup.setFocus(true);
  }

  public focusOut(): void {
    setTimeout(async () => {
      if (!this.inputData!.nativeElement.value) this.isTouched = false;
      this.checkIsValidate();
      this.errorPopup.setFocus(false);
    }, 25);
    this.focusState.emit(false);
  }

  private async checkIsValidate() {
    if (!this.valueToReturn) return;
    if (this.hasMask) {
      const { isValid, insertIcon } = await this.validateCallback(this.valueToReturn);

      if (insertIcon) this.isValidIcon = isValid;

      if (isValid) {
        this.hasError = false;
        // Zera o erro
        this.setErrorEmmiter.emit([]);
        this.validStatusEmmiter.emit(true);
      } else {
        this.hasError = true;
        this.validStatusEmmiter.emit(false);
        // Joga o erro pra ele mesmo, pra pegar no set, e conseguir deixar o controle externo,
        // pra inserção de erro de api, o erro de campo obrigatório é colocado pelo módulo,
        // sendo assim não depende do form aberto.
        this.setErrorEmmiter.emit(this.getMaskErrorCallback());
      }
    }
  }

  public copyToClipboard($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    navigator.clipboard.writeText(this.inputData.nativeElement.value).then(() => {
      this.popupFeedController.show(this.templateCopy);
      setTimeout(() => this.popupFeedController.close(), 4000);
    });
  }
}
